<template>
  <div>
    <el-button type="primary" @click="applyInvoicing">申请开票</el-button>
    <!-- 管理发票信息 -->
    <el-dialog title="申请开票" :visible.sync="invoicingVisible" width="500px" @close="closeDialog">
      <el-form ref="inovicingForm" label-width="130px" label-position="right" :model="taxInfo" :rules="rules" label-suffix="：">
        <el-form-item label="已选订单数量" prop="orderCount">
          <el-input type="input" disabled v-model="taxInfo.orderCount"></el-input>
        </el-form-item>
        <el-form-item label="开票金额" prop="makeInvoiceAmount">
          <el-input type="input" disabled v-model="taxInfo.makeInvoiceAmount"></el-input>
        </el-form-item>
        <el-form-item label="发票类型" prop="invoiceTypeLabel">
          <el-input type="input" disabled v-model="taxInfo.invoiceTypeLabel"></el-input>
        </el-form-item>
        <el-form-item label="发票抬头" prop="invoiceTitle">
          <el-input type="input" disabled v-model="taxInfo.invoiceTitle"></el-input>
        </el-form-item>
        <el-form-item label="税号" prop="taxNumber">
          <el-input type="input" disabled v-model="taxInfo.taxNumber"></el-input>
        </el-form-item>
        <el-form-item label="开户银行" prop="bankName">
          <el-input type="input" disabled v-model="taxInfo.bankName"></el-input>
        </el-form-item>
        <el-form-item label="开户账号" prop="accountNumber">
          <el-input type="input" disabled v-model="taxInfo.accountNumber"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="address">
          <el-input type="input" disabled v-model="taxInfo.address"></el-input>
        </el-form-item>
        <el-form-item label="注册电话" prop="phone">
          <el-input type="input" disabled v-model="taxInfo.phone"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="receiveUserName">
          <el-input type="input" v-model="taxInfo.receiveUserName"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="receiveUserPhone">
          <el-input type="input" v-model="taxInfo.receiveUserPhone"></el-input>
        </el-form-item>
        <el-form-item label="收票邮箱" prop="email">
          <el-input type="input" v-model="taxInfo.email"></el-input>
        </el-form-item>
        <el-form-item label="收票地址" prop="receiveAddress">
          <el-input type="input" v-model="taxInfo.receiveAddress"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button type="plain" @click="invoicingVisible = false">取消</el-button>
        <el-button type="primary" @click="saveInvoicing">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script  >
import InvoiceService from "@/apis/InvoiceService";
import orderService from "@/apis/orderService";
import { InvoiceType } from "@/service/enum";
import { Message } from "element-ui";

export default {
  props: {
    selectList: Array,
  },
  data() {
    return {
      invoicingVisible: false,
      taxInfo: {},
      rules: {
        orderCount: [
          { required: true, message: "请选择订单", trigger: "change" }
        ],
        makeInvoiceAmount: [
          { required: true, message: "请选择开票金额", trigger: "change" }
        ],
        invoiceTypeLabel: [
          { required: true, message: "请选择发票类型", trigger: "change" }
        ],
        invoiceTitle: [
          { required: true, message: "请输入发票抬头", trigger: "change" }
        ],
        taxNumber: [
          { required: true, message: "请输入税号", trigger: "change" }
        ],
        receiveUserName: [
          { required: true, message: "请输入联系人", trigger: "change" }
        ],
        receiveUserPhone: [
          { required: true, message: "请输入联系方式", trigger: "change" }
        ],
        email: [
          { required: true, message: "请输入收票邮箱", trigger: "change" }
        ],
        receiveAddress: [
          { required: true, message: "请输入收票地址", trigger: "change" }
        ],
      },
    }
  },
  methods: {
    applyInvoicing() {
      if (this.selectList.length == 0) return Message.warning("请选中需要开票的订单");
      InvoiceService.getInvoiceTaxInfo().then(res => {
        if (res) {
          this.taxInfo = res;
          this.taxInfo.invoiceTypeLabel = InvoiceType[res.invoiceType];
          this.taxInfo.orderCount = this.selectList.length;
          const totalFee = this.selectList.reduce((total, curItem) => {
            return total + curItem.platformMoney;
          }, 0)
          this.taxInfo.makeInvoiceAmount =orderService.toYuan(totalFee);
          this.invoicingVisible = true;
        } else {
          Message.warning("请点击右上角“管理发票信息”按钮，填写发票信息后，再申请开票");
        }

      })
    },
    closeDialog() {
      this.invoicingVisible = false;
      this.$refs.inovicingForm.clearValidate();
    },
    async saveInvoicing() {
      await this.$refs.inovicingForm.validate();
      const params = {
        orderDto: {
          orderCount: this.taxInfo.orderCount,
          makeInvoiceAmount: this.taxInfo.makeInvoiceAmount,
          accountNumber: this.taxInfo.accountNumber,
          address: this.taxInfo.address,
          bankName: this.taxInfo.bankName,
          compId: this.taxInfo.compId,
          email: this.taxInfo.email,
          id: this.taxInfo.id,
          invoiceTitle: this.taxInfo.invoiceTitle,
          invoiceType: this.taxInfo.invoiceType,
          phone: this.taxInfo.phone,
          receiveAddress: this.taxInfo.receiveAddress,
          receiveUserId: this.taxInfo.receiveUserId,
          receiveUserName: this.taxInfo.receiveUserName,
          receiveUserPhone: this.taxInfo.receiveUserPhone,
          taxNumber: this.taxInfo.taxNumber,
        },
        detailDto: this.selectList.map((item) => {
          return {
            compId: item.buyCompId,
            applicationId: item.applicationId,
            appName: item.appName,
            orderCreateTime: item.createDate,
            buyPeriodNum: item.packagePeriodNum,
            orderAppType: item.orderType,
            orderId: item.id,
            orderNo: item.orderNo,
            packageId: item.packageId,
            packageName: item.packageName,
            plantPrice: item.platformMoney,
            sumPrice: item.payMoney
          }
        })
      }
      InvoiceService.saveInvoiceApply(params).then(res => {
        if (res) {
          this.invoicingVisible = false;
          this.$emit("saveSuccess");
        }
      })
    }
  }
};
</script>
<style lang="scss">
.dialog-footer {
  text-align: right;
}
</style>